/**
 * Here are escape codes that can be used to style the outputs
 * on the terminal. The typical usage is to emit codes before
 * the characters to be styled and to emit the reset code at the end
 * to restore the normal styling.
 *
 * Example:   console.log(`${BOLD}${RED} bold red ${RESET}`);
 */

// code to reset the style
export const RESET =      '\x1b[0m';

// modifiers
export const BOLD =       '\x1b[1m';
export const DIM =        '\x1b[2m';
export const UNDERLINE =  '\x1b[4m';
export const BLINK =      '\x1b[5m';
export const REVERSE =    '\x1b[7m';
export const HIDDEN =     '\x1b[8m';

// foreground colors
export const BLACK =      '\x1b[30m';
export const RED =        '\x1b[31m';
export const GREEN =      '\x1b[32m';
export const YELLOW =     '\x1b[33m';
export const BLUE =       '\x1b[34m';
export const MAGENTA =    '\x1b[35m';
export const CYAN =       '\x1b[36m';
export const WHITE =      '\x1b[37m';
export const BR_BLACK =   '\x1b[90m';

// background colors
export const BG_BLACK =   '\x1b[40m';
export const BG_RED =     '\x1b[41m';
export const BG_GREEN =   '\x1b[42m';
export const BG_YELLOW =  '\x1b[43m';
export const BG_BLUE =    '\x1b[44m';
export const BG_MAGENTA = '\x1b[45m';
export const BG_CYAN =    '\x1b[46m';
export const BG_WHITE =   '\x1b[47m';
